/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { theme } from "@nordcloud/gnui";
import { Badge } from "~/components/Badge/Badge";
import { EnvironmentStatus } from "~/models";

function displayEnvStatus(value: string) {
  switch (value) {
    case EnvironmentStatus.NOT_IN_SCOPE:
      return (
        <Badge
          color={theme.color.support.teal}
          text={EnvironmentStatus.NOT_IN_SCOPE.replaceAll("_", " ")}
        />
      );
    case EnvironmentStatus.ONBOARDING:
      return (
        <Badge
          color={theme.colors.notification}
          text={EnvironmentStatus.ONBOARDING}
        />
      );
    case EnvironmentStatus.LIVE:
      return (
        <Badge color={theme.colors.success} text={EnvironmentStatus.LIVE} />
      );
    case EnvironmentStatus.OFFBOARDING:
      return (
        <Badge
          color={theme.colors.warning}
          text={EnvironmentStatus.OFFBOARDING}
        />
      );
    case EnvironmentStatus.TERMINATION:
      return (
        <Badge
          color={theme.colors.danger}
          text={EnvironmentStatus.TERMINATION}
        />
      );
    default:
      return <Badge color={theme.color.text.text01} text="UNKNOWN" />;
  }
}

export { displayEnvStatus };
